import { PaymentMode } from "types/PaymentMode";

import { IOption } from "./IOption";
import { IBaseRequest, IBaseResponse } from "./Base";
import { IComune } from "./IGeneralRequest";
import { ILuogoErogazione } from "./ILuogoErogazione";
import { AssistitoEnums } from "types/AssistitoEnums";

export interface IAssistitoBase {
	Nome: string;
	Cognome: string;
	CodiceFiscale: string;
}

export interface IAssistito extends IAssistitoBase {
	Sesso: string | undefined;
	DataNascita: string;
	// DataNascita: Moment;
	ComuneNascita: IComune | undefined;
	TelefonoContatti: string | undefined;
	IndirizzoDomicilio: string;
	IndirizzoResidenza: string;
	IndirizzoResidenzaDettagli: string;
	IndirizzoDomicilioDettagli: string;
	TelefonoResidenza: string | undefined;

	ComuneResidenza: IComune;
	ComuneDomicilio: IComune;
	MunicipioResidenza?: string;
	MunicipioDomicilio?: string;
	TelefonoDomicilio?: string;

	IdCittadinanza: number | undefined;
	LegameUtente: IOption;

	Privacy: boolean;
	ComunicazioniMMG: boolean;
	ComunicazioniServizio: boolean;
	DocSanitari: boolean;
	Terzi: boolean;
	Marketing: boolean;
}

export interface IFamiliare extends IAssistitoBase {
	Matricola: string;
	Sesso: number;
	DataNascita: string;
	UtenteIsRichiedente: boolean;
	LegameUtente: string | undefined;
	IndirizzoResidenza: string | undefined;
	IndirizzoDomicilio: string;
	TelResidenza: string | undefined;
	TelDomicilio: string;

	ComuneDomicilio: string;
	CapDomicilio: string;
	IndirizzoDomicilioDett: string;
	ComuneResidenza: string | undefined;
	CapResidenza: string | undefined;
	IndirizzoResidenzaDett: string | undefined;
	IstatDomicilio: string;
	IstatResidenza: string | undefined;
}

export interface IAnagrafica {
	Matricola: number;
	Nome: string;
	Cognome: string;
	CodiceFiscale: string;
	TelefonoContatti: string;
	TelefonoDomicilio: string;
	CapResidenza: string;
	CapDomicilio: string;
	DataNascita: Date;
	CodiceIstatComuneResidenza: string;
	ComuneResidenza: string;
	ProvinciaResidenza: string;
	CodiceMunicipioResidenza: string;
	IndirizzoResidenza: string;
	IndirizzoResidenzaDettagli: string;
	TelefonoResidenza: string;
	CodiceIstatComuneNascita: string;
	ComuneNascita: string;
	ProvinciaNascita: string;
	Sesso: string;
	CodiceIstatComuneDomicilio: string;
	IntComuneResidenza: string; // comune domicilio
	IndirizzoDomicilio: string;
	IndirizzoDomicilioDettagli: string;
	IntMunicipioRoma: string; //municipio domicilio
	IntProvinciaResidenza: string; // provincia comune domicilio
	IdCittadinanza: number;

	Privacy: boolean;
	ComunicazioniMMG: boolean;
	ComunicazioniServizio: boolean;
	DocSanitari: boolean;
	Terzi: boolean;
	Marketing: boolean;
}

export interface IPersonaRiferimento {
	Nome: string;
	Cognome: string;
	CodiceFiscale: string;
	Telefono: string;
	Sesso: AssistitoEnums;
	DataNascita: Date;
	ComuneNascita: string;
	ComuneNascitaISTAT: string;
	Cittadinanza: number;
}

export interface IPagamento {
	Skipped: boolean;
	Success: boolean;
	TransactionID: string;
	TipoPagamento: PaymentMode;
}

export interface IRegisterRequest extends IBaseRequest {
	Username: string;
	Password: string;
	ConsensoSMS: boolean | undefined;
	ConsensoMail: boolean | undefined;
	Anagrafica: IAnagrafica;
	PersonaRiferimento: IPersonaRiferimento | undefined;
	IGULegame: string;
	SessionId: string;
	IdOperatore: number;
	IguAttivita: number;
	IdEquipe: number;
	CodGruppoEquipe: string;
	Tariffa: number;
	AttivitaDalle: string;
	AttivitaAlle: string;
	Logged: boolean;
	IdCausaleIva: number;
	ImportoTariffaConIva: number;
	LuogoErogazione: ILuogoErogazione;
	ModalitaPagamento: PaymentMode;
	NoteUtente: string;
}

export interface IRegisterResponse extends IBaseResponse {
	Matricola: number;
	IdPersonaRif: number;
	CodServizio: number;
	IdPreventivo: number;
	DestinatarioPrestazione: string;
	CodPai: number;
	MailInviata: boolean;
}

export interface IMatricola {
	Matricola: number;
	IdPersonaRif?: number;
	CodServizio: number;
	IdPreventivo: number;
	CodPai: number;
	DestPrestazione: string;
	MailInviata: boolean;
}

export enum OccupazionuEnum {
	bozza = 0,
	provvisoria = 1,
	definitiva = 2,
	annullata = 3,
	consuntivata = 4,
}

export interface IPrenotazione {
	IdCodPaiPreventivo: number;
	IguAttivita: number;
	DsOccupazione: string;
	OccupazioneDa: Date;
	OccupazioneA: Date;
	IdEntita: number;
	DsEntita: string;
	Matricola: number;
	NomeAssistito: string;
	CognomeAssistito: string;
	IdPersRif: number;
	NomePersRif: string;
	CognomePersRif: string;
	IdOperatore: number;
	DsOperatore: string;
	NomeOperatore: string;
	CognomeOperatore: string;
	StatoOccupazione: OccupazionuEnum;
	Pagato: boolean;
	IguTipoPagamento: number;
	DsTipoPagamento: string;
}

export interface IPrenotazioneExt extends IPrenotazione {
	GroupByString: string;
	GroupByDate: Date;
}

export interface IDettagliPrenotazioneExt
	extends Omit<
		IPrenotazioneExt,
		"DsOccupazione" | "IdOperatore" | "DsOperatore" | "NomeOperatore" | "CognomeOperatore" | "OccupazioneDa" | "OccupazioneA"
	> {
	PrestazioniDaErogare: { IguAttivita:number, Prestazione: string; Operatore: string; OccupazioneDa: Date; OccupazioneA: Date }[];
}

export interface IGetFamiliariResponse extends IBaseResponse {
	Anagrafiche: string;
}

export interface IGetprenotazioniResponse extends IBaseResponse {
	Reservations: string;
}

export interface IRegisterFamiliareEsistenteRequest extends IBaseRequest {
	Matricola: number;
	SessionId: string;
	IdOperatore: number;
	IguAttivita: number;
	IdEquipe: number;
	CodGruppoEquipe: string;
	Tariffa: number;
	AttivitaDalle: string;
	AttivitaAlle: string;
	IdCausaleIva: number;
	LuogoErogazione: ILuogoErogazione | undefined;
	ModalitaPagamento: PaymentMode;
	NoteUtente: string;
}

export interface IRegisterFamiliareEsistenteResponse extends IBaseResponse {
	Matricola: number;
	CodServizio: number;
	IdPreventivo: number;
	DestinatarioPrestazione: string;
	CodPai: number;
	MailInviata: boolean;
}

export interface IGetLoggedUserDataResponse extends IBaseResponse {
	Nome: string;
	Cognome: string;
	CodiceFiscale: string;
	TelefonoContatti: number;
	Email: string;
	Sesso: string;
	DataNascita: Date;
	ComuneNascita: string;
	IdCittadinanaza: number;
	ConsensoSMS: boolean;
	ConsensoMail: boolean;
	IndirizzoResidenza?: string | undefined;
}

export interface IPaymentSendRequest extends IBaseRequest {
	Success: boolean;
	Skipped: boolean;
	TransactionID: string | undefined;
	IdPreventivo: number | undefined;
	PaymentMode: PaymentMode;
}

export interface IGetChangeUserDataRequest extends IBaseRequest {
	Telefono: string;
	ConsensoSMS: boolean;
	ConsensoMail: boolean;
}
